module.exports = {
  menu: {
    home: "첫 페이지",
    product: "제픔과 서비스",
    aboutus: "협력파트너(부분)",
    contactus: "연락처",
    login: "Partnerships"
  },
  select: {
    title: "언어 선택",
    lang: [
      {
        key: "zh-CN",
        name: "중국어(간체)"
      },
      {
        key: "zh-TW",
        name: "중국어(번체)"
      },
      {
        key: "en",
        name: "영어"
      },
      {
        key: "ja",
        name: "일본어"
      },
      {
        key: "ko",
        name: "한국어"
      }
    ]
  },
  brandIntro: {
    title: "상하이 푸후이 네트워크 유한공사",
    slogan: "Slogan: 디지털 기술로 글로벌 비즈니스의 지속 가능한 성장을 실현",
    intro: {
      title: "브랜드 소개",
      paragraphs: [
        "Link2shops(상하이 푸후이 네트워크 유한공사)는 국내외 기업의 디지털 성장 서비스 분야에 집중하는 AI 비즈니스 성장 솔루션 제공업체로, 매출 창출 및 회원 증가 등 성과 중심의 결과 지향적 서비스를 제공합니다. 최신 대규모 AI 모델을 깊이 통합하여 인공지능을 디지털 마케팅, 회원 혜택 서비스, 전역 고객 확보와 긴밀히 연결합니다. 시스템 개발, 공급망 협업, 유통·판촉, 정밀 운영을 아우르는 전 과정 디지털 솔루션을 제공하며, 자체 개발 AI 영업 시스템을 통해 신규 고객 확보 어려움, 낮은 전환율, 인력 효율 부족 등 핵심 과제를 직접 해결합니다. 기업이 신규 유치, 활성화, 전환, 재구매의 성장 폐루프를 효율적으로 구축할 수 있도록 지원하여, 기술 도입이 실질적인 매출 성장과 효율 향상으로 전환되도록 합니다.",
        "깊은 기술 축적과 업계 실무를 바탕으로, 자체 개발 핵심 제품 AISalesPro AI 영업 시스템을 선제적으로 구현했습니다. AI 음성 아웃바운드/온라인 AI 고객 서비스, 의도 이해, 이의 처리, 잠재 고객 선별, 전 과정 주문 성사를 일체화한 영업 역량으로 반복적인 수작업을 대체하여 기업 운영 비용을 대폭 절감하고 영업 전환 효율을 향상시킵니다. AI 기술과 비즈니스 성장의 깊은 융합을 실현하며, '기술을 위한 기술이 아닌, 기업의 성과를 위한 서비스'라는 핵심 이념을 일관되게 실천합니다."
      ]
    },
    credentials: {
      title: "권위 있는 자격 및 기술 보증",
      content:
        "국가 인증 고신기술 기업 및 상하이시 전문특신 중소기업으로서, Link2shops의 기술 체계와 전 플랫폼 서비스 시스템은 PCI DSS 결제카드 산업 데이터 보안 인증, 국가 사이버보안 등급보호 3급 인증 등 국내외 권위 있는 보안 및 기술 인증을 획득했습니다. 엄격한 컴플라이언스 기준으로 데이터 보안과 비즈니스 신뢰 방어선을 구축하여, 모든 지능형 서비스와 거래 프로세스의 안전성, 안정성, 컴플라이언스를 보장합니다."
    },
    background: {
      title: "브랜드 배경 및 글로벌 서비스 네트워크",
      content:
        "푸유(富友)그룹의 전략적 투자를 받아 상하이에 본사를 두고, 베이징, 우한, 홍콩, 도쿄 등에 지사 및 지점을 설립했습니다. 글로벌 서비스 네트워크는 중국, 일본, 한국, 싱가포르, 태국 등 다수 국가와 지역을 아우릅니다. 다년간의 업계 경험을 통해 약 300개의 유명 브랜드, 1만 개 이상의 오프라인 매장에 서비스를 제공했으며, 외식·쇼핑, 엔터테인먼트·여행, 금융 혜택, 생활 서비스 등 다양한 비즈니스 시나리오를 커버하는 글로벌·다중 시나리오·대규모 구현 서비스 역량을 갖추고 있습니다."
    },
    ecosystem: {
      title: "전역 생태계 파트너 네트워크",
      intro:
        "글로벌 최상위 비즈니스 생태계 자원과 깊이 연결되어, WeChat, Alipay, Meituan 등 주류 트래픽 플랫폼의 공식 서비스 제공업체로서 기업의 퍼블릭·프라이빗 도메인 트래픽 통합을 효율적으로 지원합니다. 핵심 생태계 파트너는 다음과 같습니다:",
      categories: [
        {
          title: "금융 기관",
          partners: ["Visa", "중국건설은행", "중국공상은행", "중국은행", "중국총상은행"]
        },
        {
          title: "항공사 및 통신사",
          partners: ["춘추항공", "중국동방항공", "길상항공", "차이나모바일"]
        },
        {
          title: "글로벌 여행 플랫폼",
          partners: ["Booking", "Agoda", "Ctrip", "Meituan", "Douyin"]
        }
      ]
    },
    aiStrategy: {
      title: "AI 전략적 배치 및 장기적 가치",
      content:
        "인공지능을 핵심 발전 전략으로 삼아, 대규모 모델 상용화, 지능형 마케팅, 기업 효율 디지털화 분야를 지속적으로 심화하고 AI 제품 포트폴리오를 지속 확장합니다. 앞으로 기업의 전 과정 경영 수요에 맞춰 AI 지능형 후속 관리, 전역 지능형 운영, 팀 효율 관리, 데이터 기반 성장 분석 등 일련의 AI 제품 및 솔루션을 순차적으로 출시할 예정입니다. 프론트엔드 지능형 고객 확보부터 미드엔드 비즈니스 전환, 백엔드 효율 관리까지 전 과정에 AI 기술로 기업의 디지털 업그레이드를 지원하여, 글로벌 비즈니스 파트너의 비용 절감, 매출 증대 및 지속적·안정적 성장을 실현합니다."
    }
  },
  products: {
    servers: [
      {
        title: "다양한 판매 서비스",
        subTitle: "소비자에게 한 번에 판매 문제를 해결해 준다.",
        desc:
          "Link2shops는 해외 서비자에게 판매 문제를 해결해 주고, 상품이나 서비스를 미리 빨리 단시간에 중국 국내나 일부분 해외에 있는  항공사,은행, OTA(온라인여행사)에게 보내 준다. 또한 온라인 주문,이동식 지불,고객 서비스,마케팅 등 여러가지 기능을 가지고 있다. 상가에게 판매액을 증가하는 동시에 더 빨리 물건을 팔 수 있도록 브랜드 영향력을 높아 주기도 한다."
      },
      {
        title: "마케팅 서비스",
        subTitle: "사업자한테 고급스러운 마케팅 서비스를 제공한다.",
        desc:
          "Link2shops는 중국에 있는 은행, 항공사,대기업 등 유명한 회사들의 권익을 유지해 주는 인터넷서비스제공업자이다. 서비자에게 거래자집단, 플랫품 특징에 따라 계획을 만들어 주고, 상가 정보도 홍보해 주기도 한다. 고급 서비자 시선을 끌리는 동시에 플랫품에 있는 브렌드 영향력을 빌려 쓰면서 상가 자기 가치를 높아 준다."
      },
      {
        title: "소매 시스템 서비스",
        subTitle: "소비지에게 소매 시스템 서비스를 제공한다.",
        desc:
          "Link2shops는 소비자에게 제공해 줄 수 있는 시스템 스프트 웨어 는 다음과 같다. 전자 쿠폰(판매하고 검증 포함), 자리 예정, 지불(aliplay,wechat,Apple play)등 여러 시스템을 제공한다."
      }
    ]
  },
  company: {
    title: "협력파트너",
    name: "상하이 부혜 인터넷 주식회사",
    website: "사이트",
    customer: "고객 서비스 전화 번호",
    business: "비즈니스협력",
    fax: "팩스",
    email: "이메일",
    address: "주소",
    addressDesc:
      "상하이시 푸동신구 찐짱로 <br>351호 푸유우 과기원 <br>6호 빌딩 4층",
    companyType1: "금융 기관",
    companyType2: "신용 있는 상점"
  },
  contact: {
    menu1: "연락처",
    menu2: "비즈니스협력"
  },
  about: {
    desc1:
      "Link2shops는 상하이 부혜 인터넷 주식 회사가 해외 서비자를 대상으로 만드는 중합 시스템 서비스 브랜드입니다. 판매,예매,홍보,지불 등 여러 문제를 해결해 줄 수 있습니다. ",
    desc2:
      "상하이 부혜 인터넷 주식 회사는 부유(富友)그룹이 전체 자금을 담당하여 창립하였습니다.  일년에 업무 규모는 8000억 인민폐(약 1150억 달러), 밑에 9개 자회사를 가지고 있습니다. 또한 세드 파트 지불 어가증을 있을 뿐만 아니라 중국 인민 은행, 중국 국가 외환 관리소 등 많은 정부 부서는 수여하는 특정 운영 허가증도 가지고 있습니다."
  }
};



// WEBPACK FOOTER //
// ./src/assets/lang/ko.js